import { includes } from 'lodash';

import { errorGQLHandler } from '../../../helpers/helpers';
import NOTICIA_TAG from '../../../graphql/revista/queries/NoticiaTags.gql';
import * as types from '../../types/post-categoria.types';
import env from '@/config/env';
import TAG_SEARCH from '@/graphql/queries/TagSearch.gql';

export default {
  namespaced: true,
  state: {
    carregando: {
      noticia: true,
      more: false,
    },
    paginate: {
      page: 1,
      next: 1,
      showButton: false,
      per_page: 20,
    },
    data: [],
  },
  getters: {
    carregando: state => state.carregando,
    getData: state => state.data,
    showButton: state => state.paginate.showButton,
  },
  mutations: {
    [types.NOTICIA](state, payload) {
      state.carregando.noticia = false;
      state.data = payload;
    },
    [types.MORE_NOTICIA](state, payload) {
      payload.forEach(item => {
        state.data.push(item);
      });
      state.carregando.more = false;
    },
    [types.PAGINATE_NOTICIA](state, payload) {
      state.carregando.more = false;
      const total_pages = Math.ceil(payload.total / payload.per_page);
      const showButton = payload.current_page < total_pages;
      state.paginate.showButton = showButton;
      state.paginate.page = payload.current_page;
      state.paginate.next = total_pages > payload.current_page ? payload.current_page + 1 : null;
    },
  },
  actions: {
    async getNoticias({ commit, state, rootGetters }, slug) {
      state.carregando.noticia = true;
      state.data = [];
      try {
        const uf = await rootGetters['user/uf'];
        const query = await env.apolloRevista.query({
          query: NOTICIA_TAG,
          variables: {
            modulo: env.revista.modulo,
            canal: env.revista.canal,
            tagSlug: slug,
            uf: [uf],
            page: 1,
            paginate: state.paginate.per_page,
          },
          fetchPolicy: 'no-cache',
        });

        const { data, ...paginate } = query.data.noticias;

        commit(types.NOTICIA, data);
        commit(types.PAGINATE_NOTICIA, paginate);
      } catch (e) {
        errorGQLHandler(e);
      }
    },
    async getMoreNoticias({ commit, state, rootGetters }, slug) {
      try {
        const page = state.paginate.next;
        state.carregando.more = true;
        const uf = await rootGetters['user/uf'];
        const query = await env.apolloRevista.query({
          query: NOTICIA_TAG,
          variables: {
            modulo: env.revista.modulo,
            tagSlug: slug,
            uf: [uf],
            page,
            paginate: state.paginate.per_page,
          },
          fetchPolicy: 'no-cache',
        });

        const { data, ...paginate } = query.data.noticias;
        commit(types.MORE_NOTICIA, data);
        commit(types.PAGINATE_NOTICIA, paginate);
      } catch (e) {
        errorGQLHandler(e);
      }
    },
    async retriveTags({ commit }, { filter = null, map = tag => tag }) {
      try {
        let response = await env.apolloRevista.query({
          query: TAG_SEARCH,
          variables: {},
          fetchPolicy: 'no-cache',
        });

        let { tags } = response.data;

        if (filter) {
          tags = tags.filter(tag => includes(filter, tag.nome));
        }

        return tags.map(map);
      } catch (e) {
        console.error(e);
        errorGQLHandler(e);
      }
    },
  },
};
